// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  npcId: __t.string().name("npc_id"),
  mapId: __t.string().name("map_id"),
  worldX: __t.i32().name("world_x"),
  worldY: __t.i32().name("world_y"),
  npcType: __t.string().name("npc_type"),
  width: __t.u32(),
  height: __t.u32(),
  metadataJson: __t.string().name("metadata_json"),
  placedBy: __t.string().name("placed_by"),
  placedAt: __t.timestamp().name("placed_at"),
});
